import {createReducer} from '@reduxjs/toolkit';

import {setLabStatus} from '../actions/labs.js';
import {get as getStored} from '../util/store.js';
import {LABS_DEFAULT, LABS_KEY} from '@explorer/constants';

const initialState = {
  ...LABS_DEFAULT,
  ...getStored(LABS_KEY),
};

const labs = createReducer(initialState, builder => {
  builder.addCase(setLabStatus, (state, {payload}) => {
    state[payload.labKey] = payload.enabled;
  });
});

export default labs;
